import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

/** @augments {PureComponent<any, any>} */
class Email extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M21.7,5.4C21.4,5.1,21.1,5,20.7,5c-1.3,0-2.6,0-3.9,0L7.1,5L3.2,5C2.5,5,2,5.5,2,6.2c0,3.8,0,7.7,0,11.5
                    C2,18.5,2.5,19,3.2,19l7.1,0l10.5,0c0.2,0,0.3,0,0.4-0.1c0.7-0.2,0.8-0.8,0.8-1.3l0-3.2c0-2.7,0-5.4,0-8.2C22,5.9,21.9,5.6,21.7,5.4
                    z M17.4,7.7l-5.2,4.5c-0.1,0.1-0.2,0.1-0.3,0L6.6,7.7C6.5,7.6,6.6,7.3,6.8,7.3h10.5C17.4,7.3,17.5,7.6,17.4,7.7z M19.5,16.7H4.5
                    c-0.1,0-0.2-0.1-0.2-0.2V9.1c0-0.2,0.2-0.3,0.3-0.2l2.6,2.2c1.3,1.1,2.7,2.3,4,3.4c0.3,0.2,0.5,0.3,0.8,0.3h0c0.3,0,0.5-0.1,0.8-0.4
                    c1.8-1.5,5.5-4.7,6.6-5.6c0.1-0.1,0.3,0,0.3,0.2v7.4C19.7,16.6,19.6,16.7,19.5,16.7z"
                />
            </SvgIcon>
        );
    }
}

export default Email;
